import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ada157ee")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_radio = _resolveComponent("s-radio")!

  return (_openBlock(), _createBlock("div", {
    class: _ctx.isHorizontal ? 'SRadioGroup__horizontal' : 'SRadioGroup'
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
      return (_openBlock(), _createBlock(_component_s_radio, {
        key: `${i}-${option}`,
        label: _ctx.getLabel(option),
        name: _ctx.groupId,
        theme: _ctx.theme,
        value: option,
        checked: JSON.stringify(option) === JSON.stringify(_ctx.value),
        disabled: option.id === _ctx.disabledOptionId || _ctx.disabledOptionsIds.includes(option.id),
        "is-horizontal": _ctx.isHorizontal,
        onChange: _ctx.emitChange
      }, null, 8, ["label", "name", "theme", "value", "checked", "disabled", "is-horizontal", "onChange"]))
    }), 128))
  ], 2))
})